const searchConstants = {
  SEARCH_REQUEST: 'SEARCH_REQUEST',
  SEARCH_SUCCESS: 'SEARCH_SUCCESS',
  SEARCH_FAILURE: 'SEARCH_FAILURE',
  SEARCH_OPEN:    'SEARCH_OPEN',
  SEARCH_CLOSE:   'SEARCH_CLOSE',
  SEARCH_RESET:   'SEARCH_RESET',
};

export default searchConstants;